const CONTENT = {
  pageDataAid: "nfoList",
  labelDataAid: "label",
  listDataAid: (idx) => `productItem_${idx}`,
  navigationHeader: {
    text: "NFO",
    dataAid: "nfo",
  },
  button: {
    text: "Invest",
  },
};
const EMPTY_LIST_SCREEN = {
  landingHeader: {
    title: "No active NFOs",
    subtitle: "You can try investing in mutual funds meanwhile",
    dataAid: "noActiveNfo",
  },
};

const NFO_FUNDS = {
  ...CONTENT,
  EMPTY_LIST_SCREEN,
};

export default NFO_FUNDS;
